<script setup lang="ts">
  import { computed } from 'vue';
  import {
    withHoverClass,
    infoListItemClass,
    itemValueClass,
    itemLabelClass,
    itemSublabelClass,
    wideSpacingClass,
    compactSpacingClass,
    noBorderClass,
  } from './InfoListItem.css.ts';
  import type { InfoListItemProps } from './InfoListItem.types.ts';

  const props = defineProps<InfoListItemProps>();

  const itemClasses = computed(() => [
    infoListItemClass,
    {
      [withHoverClass]: props.withHover,
      [wideSpacingClass]: props.wideSpacing,
      [compactSpacingClass]: props.compactSpacing,
      [noBorderClass]: props.noBorder,
    },
  ]);
</script>

<template>
  <div :class="itemClasses">
    <div :class="itemLabelClass">
      <div>{{ label }}</div>
      <div v-if="sublabel" :class="itemSublabelClass">{{ sublabel }}</div>
    </div>
    <div :class="itemValueClass">
      <slot :name="slotKey" :label="label" :value="value" v-if="slotKey">
        {{ value ? String(value) : '-' }}
      </slot>
      <template v-else> {{ value ? String(value) : '-' }}</template>
    </div>
  </div>
</template>
